import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PseudoStates, PageTitle } from '@cordata/buffet';

import {
  adminInstance as axios,
} from '~/utils';

import Form from '~/components/Department/Form';

const DepartmentsDetails = () => {
  const params = useParams();
  const [data, setData] = useState({});
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/department/${params.department_id}`)
      .then(r => r.data.data)
      .then(setData)
      .catch(setError)
      .then(() => setIsLoading(false));
  }, []);

  return (
    <>

      {!isLoading && !error ? (
        <>
          <PageTitle>{data.attributes.departmentLabel}</PageTitle>

          <Form data={data} params={params} />
        </>
      ) : (
        <PseudoStates isLoading={isLoading} data={data} error={error} />
      )}
    </>
  );
};

export default DepartmentsDetails;
